import { type TokenGroup } from "../../types";

export const white = {
  name: "white",
  variables: {
    default: { type: "color", value: { dark: "#ffffff", light: "#ffffff" } },
  },
} as const satisfies TokenGroup<"white">;
